// Persists the Home screen's selected task-type tab across reloads.
//
// We store the tab TYPE ("all" | "notes" | "backlog" | "wip" | "done"), not its
// index — the index meaning shifts when the Notes tab is hidden (notes system
// off), so an index would point at the wrong tab after a reload.

const KEY = "home_selected_task_tab";

export type TaskTabType = "all" | "notes" | "backlog" | "wip" | "done";

const VALID: TaskTabType[] = ["all", "notes", "backlog", "wip", "done"];

function isValid(value: string | null): value is TaskTabType {
  return value != null && (VALID as string[]).includes(value);
}

/** The persisted tab type, or "all" when unset/invalid. */
export function getSelectedTaskTab(): TaskTabType {
  try {
    const v = localStorage.getItem(KEY);
    return isValid(v) ? v : "all";
  } catch (e) {
    return "all";
  }
}

export function setSelectedTaskTab(type: TaskTabType): void {
  try {
    if ((VALID as string[]).includes(type)) localStorage.setItem(KEY, type);
  } catch (e) {
    /* ignore */
  }
}
